import React, { useEffect, useRef } from "react";
import styles from "./styles.module.css";
import Fb from "./icons/fb";
import Tw from "./icons/twitter";
import Tg from "./icons/telegram";
import Ig from "./icons/instagram";
import Up from "./icons/upArrow";
import cx from "classnames";

const scrollToRef = (ref) =>
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

const Footer = () => {
  const arrowRef = useRef(null);
  const executeScroll = () => scrollToRef();
  return (
    <>
      <div className={styles.root}>
        <div className={styles.grid}>
          <div
            className={cx(styles.icon, styles.upIcon)}
            onClick={executeScroll}
            ref={arrowRef}
          >
            <a>
              <Up />
            </a>
          </div>
          <div className={styles.flexColumn}>
            <p className={styles.copyright}>
              <a href="tel:+7 (495) 150-37-60" className={styles.phone}>
                +7 (495) 150-37-60
              </a>
              <br />
              <a href="mailto:yo@guidedao.xyz" className={styles.email}>
                yo@guidedao.xyz
              </a>
            </p>

            <div className={styles.flex}>
              <div className={styles.icon}>
                <a
                  href="https://www.instagram.com/guidedao.xyz/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Ig />
                </a>
              </div>
              <div className={styles.icon}>
                <a
                  href="https://t.me/deepdepeg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tg />
                </a>
              </div>
              <div className={styles.icon}>
                <a
                  href="https://twitter.com/guidedao"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tw />
                </a>
              </div>
              <div className={styles.icon}>
                <a
                  href="https://www.facebook.com/guidedao.xyz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Fb />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
